import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { WarehouseInfos } from "models/PlanInfos";
import { useEffect } from "react";
import { useGetWarehousePlanQuery } from "services/api/warehouseApi";
import { setWarehousePlan } from "store/Slices/warehousePlanSlice";
import { useAppDispatch } from "./StoreHooks";

// GT: Retirer initialPlan pour la mise en prod
export function useWarehousePlan(
  storeNb: number,
  initialPlan?: WarehouseInfos
): {
  data: WarehouseInfos | undefined;
  isLoading: boolean;
  error: FetchBaseQueryError | undefined;
} {
  const dispatch = useAppDispatch();

  const {
    data: fetchedPlan,
    isLoading,
    isFetching,
    error: queryError,
  } = useGetWarehousePlanQuery(storeNb);

  useEffect(() => {
    if (initialPlan) {
      dispatch(setWarehousePlan(initialPlan));
    } else if (fetchedPlan) {
      dispatch(setWarehousePlan(fetchedPlan));
    }
  }, [dispatch, initialPlan, fetchedPlan, storeNb]);

  return {
    data: initialPlan ? initialPlan : fetchedPlan,
    isLoading: isLoading || isFetching,
    error: queryError ? (queryError as FetchBaseQueryError) : undefined,
  };
}
